import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.handleToastShow = this.handleToastShow.bind(this)
    window.addEventListener("toast:show", this.handleToastShow)
  }

  disconnect() {
    window.removeEventListener("toast:show", this.handleToastShow)
  }

  handleToastShow(event) {
    const { message, type = "info" } = event.detail

    const toast = document.createElement("div")

    const alertClass = {
      success: "alert-success",
      error: "alert-danger",
      warning: "alert-warning",
      info: "alert-info"
    }[type] || "alert-info"

    const iconClass = {
      success: "fas fa-check-circle",
      error: "fas fa-times-circle",
      warning: "fas fa-exclamation-triangle",
      info: "fas fa-info-circle"
    }[type] || "fas fa-info-circle"

    toast.className = `alert ${alertClass} d-flex align-items-center mb-2`
    toast.style.cssText = "min-width: 250px; opacity: 0; transform: translateX(100%); transition: all 0.3s ease; cursor: pointer; padding: 10px 15px; font-size: 0.85rem;"
    toast.innerHTML = `<i class="${iconClass} mr-2"></i> ${message}`

    toast.addEventListener("click", () => this.closeToast(toast))

    const timeoutId = setTimeout(() => this.closeToast(toast), 3000)
    toast.dataset.timeoutId = timeoutId

    this.element.appendChild(toast)

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        toast.style.opacity = "1"
        toast.style.transform = "translateX(0)"
      })
    })
  }

  closeToast(toast) {
    if (!toast.parentElement || toast.dataset.closing === "true") return
    toast.dataset.closing = "true"

    const timeoutId = parseInt(toast.dataset.timeoutId)
    if (timeoutId) clearTimeout(timeoutId)

    toast.style.opacity = "0"
    toast.style.transform = "translateX(100%)"

    setTimeout(() => {
      if (toast.parentElement) toast.remove()
    }, 300)
  }
}
